import React from 'react';
import { createRoot } from 'react-dom/client';
import Panniers from './Panniers.tsx';
import * as Sentry from '@sentry/react';
import { AppStateProvider } from './State.tsx';

const rootElement = document.getElementById('REACT_FitAssistant_new');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <AppStateProvider>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <Panniers />
      </Sentry.ErrorBoundary>
    </AppStateProvider>
  );
}
